import React, { useState, useCallback } from "react";
import { MdCancel, MdCheckCircle, MdExpandMore } from "react-icons/md";
import { FormattedDate, useIntl } from "react-intl";
import { formatCpfCnpj } from "~/utils/format";

const DocumentCriteria = ({ criteria, openCriteria, toggleCollapse, selectedCriteria }) => {
  const [documentsCollapsed, setDocumentsCollapsed] = useState(false);
  const { formatMessage } = useIntl();

  const hasDocumentInfractions = useCallback(() => {
    if (!criteria) return false;
    return !!criteria.find(crit => crit.documents.has_infractions.length > 0);
  }, [criteria]);

  return (
    <div className={`report-section${documentsCollapsed ? " collapsed" : ""}`}>
      <h3
        className="document-name"
        onClick={() => setDocumentsCollapsed(!documentsCollapsed)}
      >
        <MdExpandMore className="collapse-indicator" />{" "}
        {formatMessage({ id: "criterios" })}
        {hasDocumentInfractions() ? (
          <MdCancel className="section-status-icon error" />
        ) : (
          <MdCheckCircle className="section-status-icon check" />
        )}
      </h3>
      {criteria.map(criterion => {
        // Verifique se o critério tem um ID válido e está entre os selecionados
        if (!criterion.B3Criterio.id || !selectedCriteria.includes(criterion.B3Criterio.id)) {
          return null;
        }

        return (
          <div
            key={criterion.B3Criterio.id}
            className={`criteria-information-data${!openCriteria.includes(criterion.B3Criterio.id)
              ? " collapsed"
              : ""
              }
            ${criterion.documents.has_infractions.length > 0
                ? " criteria-desconforme"
                : " criteria-conforme"
              }
              `}
          >
            <div
              className="criteria-title"
              onClick={() => toggleCollapse(criterion.B3Criterio.id)}
            >
              <div className="text">
                <div>
                  <MdExpandMore size="18px" />
                </div>
                <div>{criterion.B3Criterio.nome}</div>
              </div>
              {!!criterion.documents.clean.find(
                doc => doc.status !== "processado"
              ) ? (
                <div className="loader tiny"></div>
              ) : (
                <div>
                  {criterion.documents.has_infractions.length > 0 ? (
                    <MdCancel size={20} className="error-icon" />
                  ) : (
                    <MdCheckCircle size={20} className="check-icon" />
                  )}
                </div>
              )}
            </div>
            <div className="criteria-details">
              {criterion.B3Criterio.descricao && (
                <div>
                  <span className="bold">
                    {formatMessage({ id: "descricao" })}:{" "}
                  </span>
                  {criterion.B3Criterio.descricao}
                </div>
              )}
              {criterion.B3Criterio.fonte && (
                <div>
                  <span className="bold">
                    {formatMessage({ id: "fonte" })}:{" "}
                  </span>
                  <a
                    href={criterion.B3Criterio.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {criterion.B3Criterio.fonte}
                  </a>
                </div>
              )}
              {criterion.B3CriterioVersao &&
                criterion.B3CriterioVersao.data && (
                  <div>
                    <span className="bold">
                      {formatMessage({ id: "data-base" })}:{" "}
                    </span>
                    <FormattedDate
                      value={new Date(criterion.B3CriterioVersao.data)}
                    />
                  </div>
                )}
              {criterion.data_consulta && (
                <div>
                  <span className="bold">
                    {formatMessage({ id: "data-consulta" })}:{" "}
                  </span>
                  <FormattedDate value={new Date(criterion.data_consulta)} />
                </div>
              )}
              {criterion.documents.has_infractions.length === 0 ? (
                <>
                  {criterion.B3Criterio.slug === "dap" ? (
                    <div className="infraction">
                      <div>
                        <div className="status-icon">
                          <MdCheckCircle size={20} className="check-icon" />
                        </div>
                        <span className="bold">
                          {formatMessage(
                            {
                              id: "x-ocorrencias-encontradas"
                            },
                            {
                              num: criterion.documents.clean.length
                            }
                          )}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="infraction">
                      <div>
                        <div className="status-icon">
                          <MdCheckCircle size={20} className="check-icon" />
                        </div>
                        <span className="bold">
                          {formatMessage({
                            id: "nenhuma-infracao-documento"
                          })}
                        </span>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <>
                  {criterion.documents.has_infractions.map(doc => {
                    return (
                      doc.descricao &&
                      doc.descricao.map((infraction, infractionKey) => (
                        <div
                          key={`${doc.B3PessoaConsultada.cpf_cnpj}-${infractionKey}`}
                          className="infraction"
                        >
                          <div>
                            <div className="status-icon">
                              <MdCancel size={20} className="error-icon" />
                            </div>
                            <span className="bold">
                              {formatCpfCnpj(doc.B3PessoaConsultada.cpf_cnpj)}
                            </span>
                          </div>
                          {infraction.map(detail => (
                            <p key={detail.nome}>
                              <span className="bold">{detail.nome}: </span>
                              {detail.valor}
                            </p>
                          ))}
                        </div>
                      ))
                    );
                  })}
                  {criterion.documents.clean.length > 0 && (
                    <div className="infraction">
                      <div>
                        <div className="status-icon">
                          <MdCheckCircle size={20} className="check-icon" />
                        </div>
                        <div>
                          <span className="bold">
                            {criterion.B3Criterio.slug === "dap" ? (
                              <>
                                {formatMessage({
                                  id: "cpfs-com-dap"
                                })}
                              </>
                            ) : (
                              <>
                                {formatMessage({
                                  id: "documentos-sem-problemas"
                                })}
                              </>
                            )}
                            :{" "}
                          </span>
                          {criterion.documents.clean
                            .map(doc =>
                              formatCpfCnpj(doc.B3PessoaConsultada.cpf_cnpj)
                            )
                            .join(", ")}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DocumentCriteria;
